import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { PleadDialogComponent } from '@dialog/plead-dialog/plead-dialog.component';
import { ViolationInformationDialogComponent } from '@dialog/violation-information-dialog/violation-information-dialog.component';
import { BaseComponent } from '@library-shared/base/base.component';
import { spTicket_List } from '@models/StoredProcs/spTicket_List';
import dayjs from 'dayjs';

/*
K143CCS4HL

*/


@Component({
    selector: 'app-ticket-select-display',
    templateUrl: './ticket-select-display.component.html',
    styleUrls: ['./ticket-select-display.component.scss'],
    standalone: false
})
export class TicketSelectDisplayComponent extends BaseComponent implements OnInit {
    @ViewChild('pleadDialog') pleadDialog: PleadDialogComponent;
    @ViewChild('violationInfo') violationInfo: ViolationInformationDialogComponent;

    @Input() ticketList: spTicket_List[] = [];
    @Input() itemCount: number;
    @Input() index: number;

    @Output() selectionChanged = new EventEmitter<any>();

    constructor() {
        super();
    }

    ngOnInit(): void {}

    ticketTypeName(ticketType: string): string {
        switch (ticketType) {
            case 'T':
                return 'Traffic Summons';
            case 'P':
                return 'Parking Summons';
            case 'R':
                return 'Red Light Notice';
            case 'S':
                return 'Speeding Notice';
        }
        return '?';
    }

    onSelectedChanged(e: any) {
        this.selectionChanged.emit(e);
    }

    ticketStatus(rec: spTicket_List): string {
        if (rec.ticket_status_code === 'CL') {
            return 'Closed';
        }
        if (rec.is_must_appear) {
            return 'APPEAR';
        }
        return '';
    }

    mustAppear(rec: spTicket_List): boolean {
        return rec.is_must_appear && rec.ticket_status_code === 'OP';
    }

    action(rec: spTicket_List): string {
        if (rec.ticket_status_code === 'CL') {
            return `${rec.ticket_status_name}:`;
        }
        if (rec.ticket_state_name) {
            return rec.ticket_state_name;
        }
        return rec.calendar_code_name;
    }

    actionDate(rec: spTicket_List): Date {
        if (rec.ticket_status_code === 'CL') {
            return rec.close_date;
        }
        if (rec.ticket_state_name) {
            return null;
        }
        return rec.calendar_datetime;
    }


    actionDateFormat(rec: spTicket_List): string {
        if (rec.ticket_status_code === 'CL') {
            return this.dateFormat;
        }
        return this.dateTimeFormat;
    }



    isPastDue(rec: spTicket_List): boolean {
        if (!rec.payment_due_date) {
            return false;
        }
        if (rec.ticket_balance <= 0) {
            return false;
        }
        if (rec.ticket_state_code != null) {
            return false;
        }
        if (rec.calendar_datetime != null) {
            return dayjs(rec.payment_due_date).isBefore(dayjs().startOf('day'))
                && dayjs(rec.calendar_datetime).isBefore(dayjs().startOf('day'));
        }
        return dayjs(rec.payment_due_date).isBefore(dayjs().startOf('day'));
    }

    showResolve(rec: spTicket_List) {
        this.pleadDialog.showDialog(rec);
    }

    showInformation(rec: spTicket_List) {
        this.violationInfo.showDialog(rec);
    }
}
